module.exports = __webpack_public_path__ + "static/JDeveaux-logo.05c299b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/JDeveaux-logo.svg
// module id = 95
// module chunks = 35783957827783 79611799117203